import { BaseFeatureToggles } from '../store/navigation/BaseFeatureToggles';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * Whether the active partner has bought order-to-ship.
 *
 * This is the commercial gate and the only enablement question left on a schedule: every warehouse
 * of an entitled partner is a candidate, and opting one out is done by setting an override rather
 * than by a per-schedule flag. It is named rather than read inline because more than one component
 * has to agree on it — if the form that renders the OTS controls and the callers that seed its
 * initial values disagree, a partner who cannot see the controls still gets their values rewritten.
 */
export const useOtsEntitled = (): boolean => useFeatureFlag(BaseFeatureToggles.OTS_CALCULATION);
